import Ads from './modules/ads';

window.Ads = new Ads();
